import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import SearchContext from '../context/SearchContext'
import AppContext from '../context/AppContext'
import Sort from './Sort'
import Tags from './Tags'
import MonitoringModal from './MonitoringModal'

const StickyHeader = () => {

    const {carsInStock } = useContext(SearchContext)
    const {monitoring_url } = useContext(AppContext)

    const [isSticky, setIsSticky] = useState(false)
    const [showMonitoring, setShowMonitoring] = useState(false)

    const headerRef = useRef()

    const closeMonitoring = useCallback(() => setShowMonitoring(false), [])

    // mount 
    useEffect(()=>{
        const cachedRef = headerRef.current,
            observer = new IntersectionObserver(
                ([e]) => setIsSticky(e.intersectionRatio < 1),
                {threshold: [1]}
            )

        observer.observe(cachedRef)
        
        // unmount
        return function(){
            observer.unobserve(cachedRef)
        }
    }, [])

    return (
        <div ref={headerRef} className={'cars-header' + (isSticky ? ' sticky' : '')}>
            <h3><span>{carsInStock}</span> {carsInStock === 1 ? 'bil':'bilar'} i lager</h3>
            {isSticky  &&
                <Tags />
            }
            <div className="right-side">
                { monitoring_url &&
                    <button className="monitoring-btn" onClick={() => setShowMonitoring(true)}>Starta bevakning</button>
                }
                <Sort />
            </div>
            { monitoring_url && showMonitoring &&
                <MonitoringModal url={monitoring_url} onClose={closeMonitoring} />
            }
        </div>
    )

}

export default StickyHeader
